module.exports = __webpack_public_path__ + "img/layout_ladder.779d8785.svg";